class StringUtils {
  static toFilterText(text: string) {
    if (text) {
      const words: string[] = text.split(' ');
      if (words.length > 1) {
        for (let i = 0; i < words.length; i++) {
          words[i] = '"' + words[i] + '"';
        }
      }
      text = words.join(' ');
    }
    return text;
  }

  static fromFilterText(text: string) {
    if (text) {
      text = text.replaceAll('"', '');
      if (text.length > 30) {
        text = text.substring(0, 28) + '..';
      }
    }
    return text;
  }

  static isValidCompanyUrl(url: string): boolean {
    const validEndings = [
      '.com',
      '.de',
      '.org',
      '.net',
      '.info',
      '.at',
      '.eu',
      '.ch',
      '.group',
      '.co.at',
      '.swiss',
      '.nl',
      '.biz',
    ];
    const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    return pattern.test(url) && validEndings.some((ending) => url.endsWith(ending));
  }

  static isValidPlatformUrl(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  static toTitleCase(str: string): string {
    const words = str.split(' ');
    return words.map((word) => word.slice(0, 1).toUpperCase() + word.slice(1)).join(' ');
  }
}

export default StringUtils;
